import { get, isEmpty, values, filter, uniqBy, groupBy } from 'lodash'
import { createSelector } from 'reselect'
import { getAllConfigurationModels } from 'store/ConfigurationModels/selectors'
import { getItems } from 'store/Items/selector'
import { getMenus } from 'store/Menus/selectors'
import { transformMenusWithConfigurationModelName } from 'utils/revenueCenters/transfromMenusWithConfigurationModelName'

// Revenue Centers //

export const getRevenueCenters = (state) =>
  values(get(state, 'revenueCenters.byId'))

export const getRevenueCenter = (state, revenueCenterId) =>
  get(state, `revenueCenters.byId.${revenueCenterId}`, {})

export const getCurrentRevenueCenter = (state, revenueCenterId) =>
  state?.revenueCenters?.pagination?.byId?.[revenueCenterId] ?? {}

export const getPaginatedRevenueCenters = (state) =>
  values(state?.revenueCenters?.pagination?.byId) ?? []

export const getTotalRevenueCentersCount = (state) =>
  state?.revenueCenters?.pagination?.total ?? 0

export const makeGetRevenueCenter = () =>
  createSelector([getRevenueCenter], (revenueCenter) => revenueCenter)

export const getIsRevenueCentersLoading = (state) =>
  state?.revenueCenters?.isLoading ?? false

export const getMenusForRevenueCenter = (state, id) => {
  // There is require revenue center id not uuid!
  const allMenus = getMenus(state)
  const allConfigurationModels = getAllConfigurationModels(state)

  const menusWithConfigurationModelName =
    transformMenusWithConfigurationModelName(
      allMenus,
      allConfigurationModels
    )

  const menusAssignedToRevenueCenter = filter(
    menusWithConfigurationModelName,
    (menu) => menu.standId === id
  )

  return menusAssignedToRevenueCenter ?? []
}

export const getGroupedMenusForCurrentRevenueCenter = createSelector(
  getMenus,
  getAllConfigurationModels,
  (allMenus, allConfigurationModels) => {
    const menusWithConfigurationModelName =
      transformMenusWithConfigurationModelName(
        allMenus,
        allConfigurationModels
      )

    return groupBy(menusWithConfigurationModelName, 'standId') ?? {}
  }
)

export const getFilteredDataForRevenueCenter = (state, id) => {
  if (isEmpty(state?.revenueCenters?.pagination?.byId)) {
    return {
      location: [],
      cuisine: [],
    }
  }

  return (
    state?.revenueCenters?.pagination?.byId[id]?.filterData ?? {
      location: [],
      cuisine: [],
    }
  )
}

// assigned items
export const getAssignedItemsToMenu = (state, uuid) => {
  const allItems = getItems(state)
  const assignedItems = allItems.filter((item) =>
    item?.menuUuids?.includes(uuid)
  )

  return assignedItems ?? []
}

// get assigned items to menus
export const getAssignedItemsToMenus = (state, menusUuids) => {
  const allItems = getItems(state)
  return (
    menusUuids?.reduce((acc, menuUuid) => {
      const assignedItems = allItems?.filter((item) =>
        item?.menuUuids?.includes(menuUuid)
      )

      const assignedItemsUuids = assignedItems?.map(
        ({ uuid }) => uuid
      )

      return [...acc, { menuUuid, assignedItemsUuids }]
    }, []) ?? []
  )
}

// Availability

export const getIsLoadingAvailability = (state) =>
  state?.revenueCenters?.availability?.loading

export const getMenusStatus = (state, id) => {
  const revenueCenterAvailability =
    state?.revenueCenters?.availability?.byId?.[id]

  const uniqServiceType = uniqBy(
    revenueCenterAvailability?.serviceTypes,
    'type'
  )

  const serviceTypesAvailability = uniqServiceType.map(
    ({ type, availability }) => {
      const upperCaseType = type?.toUpperCase()
      return {
        type: upperCaseType,
        availability,
      }
    }
  )

  return serviceTypesAvailability
}

// Images
export const getRevenueCenterImage = (state, uuid) => {
  return state?.revenueCenters?.images?.list[uuid] ?? null
}
